import { useContext } from 'react';
import classes from './NewsMainBlock.module.css';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../../../App';
import { ImageNotSupportedIcon } from '../../../icons/ImageNotSupported';

interface NewsMainBlockProps {
  image: string | undefined;
  url: string;
  title: string;
  description: string;
  published: string;
}

const NewsMainBlock = ({
  image,
  url,
  title,
  description,
  published,
}: NewsMainBlockProps) => {
  const { theme } = useContext(ThemeContext);

  return (
    <Link
      to={url}
      id={classes[theme]}
      className={classes.newsMainBlock + ' h-vh20 md:h-vh40 lg:h-vh30'}
    >
      <div className={classes.leftSide}>
        {image ? (
          <img src={image} alt={title} />
        ) : (
          <div className={classes.imageNotFound}>
            <ImageNotSupportedIcon
              styles={{ width: 60, height: 60 }}
              iconColor={theme === 'dark' ? 'white' : 'black'}
            />
          </div>
        )}
      </div>
      <div className={classes.rightSide}>
        <p
          className={
            classes.category +
            ' text-smAddTxt md:text-mdAddTxt lg:text-lgAddTxt'
          }
        >
          {published ? published.substring(0, 10) : null}
        </p>
        <h4
          className={
            classes.newsTitle +
            ' text-smSepBtnTxt md:text-mdTitlesForH lg:text-lgTitlesForH'
          }
        >
          {title}
        </h4>
        <p className={classes.description + ' hidden lg:block'}>
          {description}
        </p>
      </div>
    </Link>
  );
};

export default NewsMainBlock;
